fp.Module.View = fp.Module.extend({
    construct: function(element, config, template, parent) {
        config = _.defaults(config, {
            priority: fp.constants.priority.MAJOR,
            enableLazyInit: false,
            disableShowProgress: false
        });

        this._super(element, config, template, parent);

        if(!fpConfig.enableModuleCss && !fpConfig.enableMobile) {
            this.dependencies.load.file.push('freshop-module.css');
        }

        var $element = this.$element;
        if(!$element.attr('data-role')) {
            $element.attr('data-role', 'handle-errors');
        }

        $element.replaceClass('fp-module', 'fp-module fp-module-view');
    },
    init: function(autoRender) {
        var self = this,
            _super = this._super,
            promise;

        if(fp.loaded) {
            promise = fpService.assetVersionService
                .get()
                .then(function (resp) {
                    if (!fp.isUnloading && resp.deploy_id && resp.deploy_id !== fp.deployId && !fp.getSessionCookie().reload) {
                        fp.setSessionCookie({reload: true});

                        fp.isUnloading = freshop.unloading = true;
                        window.location.reload();
                    }
                });
        }

        promise = $.when(promise)
            .then(function() {
                return _super.call(self, autoRender);
            });

        fpUtil.showProgress(promise);

        return promise;
    },
    //render: function() {
    //    this._super.apply(this, arguments);
    //
    //    if(!fp.loaded) {
    //        $(this.scope).one(fp.events.RENDERED, function() {
    //            fpUi.unblockUI({force: true});
    //            fp.viewModuleRenderTime = new Date();
    //        });
    //    }
    //},
    __attachScopeEvents: function() {
        this._super();

        var self = this;

        _.defer(function(){
            $(self.scope)
                .one(fp.events.VIEW_MODULE_RENDERED, function (event) {
                    if(!fp.loaded && $(event.target).data('fp.ui.Component') === self) {
                        $.when.apply($, event.promises)
                            .always(function () {
                                fpUi.unblockUI({force: true});
                                fp.viewModuleRenderTime = new Date();
                            });
                    }
                });
        });
    }
});